import { UPDATE_WRITING_CHAPTER } from '../actions/writing';

export const updateWritingChapterReducer = (state = '', action) => {
  switch (action.type) {
    case UPDATE_WRITING_CHAPTER:
      return action.payload;
  }
  return state;
};
